export default __webpack_public_path__ + "static/media/INSTA.7814ad0a.svg";